import axios from "axios"
import { useMemo } from "react"
import useSWR from "swr"
import { getCurrentBranch, getUser } from "helpers/auth-helper"

const fetcher = async (url, params) => {
    return await axios.get(url, { params }).then(res => res.data.data)
}

const isSuperUser = () => {
    const user = getUser()
    const currentBranch = getCurrentBranch()

    if (!user) return false
    if (currentBranch?.roles?.find((role) => role.is_super === 1)) return true
    if (user?.roles?.find((role) => role.is_super === 1)) return true

    return false
}

const restrictBranches = (data) => {
    if (data == null) return data
    if (isSuperUser()) return data

    const currentBranch = getCurrentBranch()
    if (!currentBranch?.id) return data

    const allowedId = String(currentBranch.id)

    if (Array.isArray(data)) {
        return data.filter((row) => String(row?.id ?? "") === allowedId)
    }

    if (Array.isArray(data?.data)) {
        return {
            ...data,
            data: data.data.filter((row) => String(row?.id ?? "") === allowedId),
        }
    }

    return data
}

const useBranchRepositories = (params) => {
    const { data, error, mutate } = useSWR([`${process.env.REACT_APP_GENERIC_API_URL}/branch`, params], fetcher)

    const restricted = useMemo(() => restrictBranches(data), [data])

    return {
        data: restricted,
        isLoading: !error && !data,
        error,
        mutate
    }
}

export default useBranchRepositories